import MakeDelivery from './MakeDelivery';
export default MakeDelivery;
